import { render, staticRenderFns } from "./addGiftNumber.vue?vue&type=template&id=0c6fbab1&scoped=true"
import script from "./addGiftNumber.vue?vue&type=script&lang=js"
export * from "./addGiftNumber.vue?vue&type=script&lang=js"
import style0 from "./addGiftNumber.vue?vue&type=style&index=0&id=0c6fbab1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6fbab1",
  null
  
)

export default component.exports